import { AllTileTypes } from "../../boardTypes";
import type { Tile } from "../../../types/tile";
import type { TileGrouper } from ".";

export const groupByTileType: TileGrouper = (tiles) => {
    // Sort by colour, then tile type
    tiles.sort((a, b) => a.Colour - b.Colour);
    tiles.sort((a, b) => a.TileType - b.TileType);

    let outputTiles: Tile[][] = [];

    for (const tileType of AllTileTypes()) {
        const tilesOfThisType = tiles.filter(
            (tile) => tile.TileType === tileType
        );

        if (tilesOfThisType.length > 0)
            outputTiles = [...outputTiles, tilesOfThisType];
    }

    return outputTiles;
};
